import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from "axios";
import TitleCard from '../../../components/TitleCard/TitleCard';
import ConfirmModal from '../../../components/ConfirmModal/ConfirmModal';
import GradientButton from '../../../components/GradientButton/GradientButton';
import CancelButton from '../../../components/CancelButton/CancelButton';

const RolesCreate = ({ onSubmit }) => {
    const navigate = useNavigate();
    const [formData, setFormData] = useState({
        name: '',
        description: '',
        active: true,
    });

    const [showConfirm, setShowConfirm] = useState(false);
    const [confirmData, setConfirmData] = useState({
        title: '',
        message: '',
        type: 'info', // success | error | warning
    });

    const [isSubmitting, setIsSubmitting] = useState(false); // ✅ Estado para controlar el botón

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData(prevState => ({
            ...prevState,
            [name]: value
        }));
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setIsSubmitting(true); // 🔒 Deshabilitamos el botón al enviar

        try {
            const token = localStorage.getItem('access_token');
            await axios.post(
                `${process.env.REACT_APP_API_URL}/roles/create`,
                formData,
                { headers: { Authorization: `Bearer ${token}` } }
            );

            setConfirmData({
                title: 'Rol creado',
                message: `El Rol "${formData.name}" fue creado exitosamente.`,
                type: 'success',
            });
            setShowConfirm(true);

        } catch (err) {
            console.error('Error creando rol:', err);
            setConfirmData({
                title: 'Error',
                message: err.response?.data?.message || 'No se pudo crear el rol. Intenta nuevamente.',
                type: 'error',
            });
            setShowConfirm(true);
        }
    };

    const handleConfirm = () => {
        setShowConfirm(false);
        setIsSubmitting(false); // 🔓 Reactivamos el botón al cerrar el modal

        if (confirmData.type === 'success') {
            navigate('../users/roles-list');
        }
    };

    return (
        <>
            <TitleCard title="Crear Rol" />

            <form
                onSubmit={handleSubmit}
                className="bg-white px-6 py-6 mt-4 rounded-lg shadow-md flex flex-col gap-4 w-full"
            >
                {/* Grid de 2 columnas */}
                <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
                    <div className="flex flex-col">
                        <label htmlFor="name" className="text-gray-600 mb-1">Nombre</label>
                        <input
                            type="text"
                            name="name"
                            id="name"
                            value={formData.name}
                            onChange={handleChange}
                            className="border border-gray-300 rounded px-3 py-2 focus:outline-none focus:ring-2 focus:ring-blue-600"
                            required
                        />
                    </div>

                    <div className="flex flex-col">
                        <label htmlFor="description" className="text-gray-600 mb-1">Descripción</label>
                        <input type="text" name="description" id="description" value={formData.description} onChange={handleChange} className="border border-gray-300 rounded px-3 py-2 focus:outline-none focus:ring-2 focus:ring-blue-600" required/>
                    </div>

                    <div className="flex items-center gap-4 mt-2">

                        <label htmlFor="active" className="text-gray-600 font-normal">
                            Estado:
                        </label>

                        <button type="button" className={`relative inline-flex h-7 w-14 items-center rounded-full transition-colors duration-300 ${formData.active ? "bg-blue-600" : "bg-gray-300"}`}
                            onClick={() =>
                                setFormData(prev => ({
                                    ...prev,
                                    active: !prev.active
                                }))
                            }
                        >
                            <span className={`inline-block h-5 w-5 transform rounded-full bg-white transition-transform duration-300 ${formData.active ? "translate-x-8" : "translate-x-1"}`} />
                        </button>

                        <span className="text-sm text-gray-500">
                            {formData.active ? "Activo" : "Inactivo"}
                        </span>

                    </div>

                    <div className="flex self-end gap-2">
                        <GradientButton type="submit" disabled={isSubmitting}>
                            {isSubmitting ? 'Creando...' : 'Aceptar'}
                        </GradientButton>
                        <CancelButton onClick={() => navigate(-1)} />
                    </div>

                </div>
            </form>

            {/* Modal de confirmación */}
            <ConfirmModal
                isOpen={showConfirm}
                title={confirmData.title}
                message={confirmData.message}
                type={confirmData.type}
                onConfirm={handleConfirm}
                onClose={() => {
                    setShowConfirm(false);
                    setIsSubmitting(false); // 🔓 También reactivamos si se cierra sin confirmar
                }}
            />
        </>
    );
};

export default RolesCreate;